<template>
   <el-menu class="site-navbar" :default-active="activeMenuItem" :mode="$teras.app.device=='desktop' ? 'horizontal' : 'vertical'" :router="true" :ellipsis="false">

      <el-sub-menu index="who-we-are">
         <template #title>WHO WE ARE</template>
         <el-menu-item index="/who-we-are/about-us">About us</el-menu-item>
         <el-menu-item index="/who-we-are/membership">Membership</el-menu-item>
         <el-menu-item index="/who-we-are/executive-board">Executive Board</el-menu-item>
         <!--<el-menu-item index="/who-we-are/task-forces">Task Forces</el-menu-item>-->
         <el-menu-item index="/who-we-are/divisions">Divisions</el-menu-item>
         <el-menu-item index="/who-we-are/international-collaborations">International Collaborations</el-menu-item>
      </el-sub-menu>

      <el-sub-menu index="calendar">
         <template #title>CALENDAR</template>
         <el-menu-item index="/calendar/events">Events</el-menu-item>
         <el-menu-item index="/calendar/how-to-get-eflm-auspices">How to get EFLM auspices</el-menu-item>
      </el-sub-menu>

      <el-menu-item index="/eflm-publications">EFLM PUBLICATIONS</el-menu-item>
      <el-menu-item index="/newsletters">EUROLABNEWS</el-menu-item>
      <el-menu-item index="/contact">CONTACT</el-menu-item>
      <el-menu-item class="special-menu-item special-menu-item--secondary" index="/eflm-platforms">EFLM PLATFORMS</el-menu-item>
      <a v-if="$teras.app.device!='desktop'" href="https://academy.eflm.eu/secretariat" target="_blank"><li class="el-menu-item">EFLM ACADEMY LOGIN</li></a>
   </el-menu> 
</template>

<script>
import { ElMenu, ElMenuItem, ElSubMenu } from 'element-plus'
export default {
   components: {
      ElMenu, ElMenuItem, ElSubMenu
   },
   name: "site-navbar",
   computed: {
      activeMenuItem: function (){
         return this.$route.path
      }
   }
}
</script>